<div class="assessment-page">
  <div class="assessment-header">
    <h1 class="assessment-title">Proctored Assessment</h1>
    <p class="assessment-subtitle">
      Data Science Intern at Synaptic AI · 45 minutes · 6 questions
    </p>
  </div>
  <div class="card">
    <h3 class="card-title">Rules</h3>

    <ul class="rules-list">
      <li>Stay in full-screen mode throughout</li>
      <li>Do not switch browser tabs</li>
      <li>Camera must remain on (proctoring active)</li>
      <li>No external assistance</li>
    </ul>
  </div>
  <div class="card">
    <h3 class="card-title">System check</h3>
    <div class="system-row">
      <div class="left">
        <i class="bi bi-camera"></i>
        Camera
      </div>

      <div
        class="status"
        [ngClass]="cameraDetected ? 'detected' : 'not-detected'"
      >
        {{ cameraDetected ? "Detected" : "Not detected" }}
      </div>
    </div>
    <div class="system-row">
      <div class="left">
        <i class="bi bi-mic"></i>
        Microphone
      </div>

      <div class="status" [ngClass]="micDetected ? 'detected' : 'not-detected'">
        {{ micDetected ? "Detected" : "Not detected" }}
      </div>
    </div>
    <div class="system-row">
      <div class="left">
        <i class="bi bi-speedometer2"></i>
        Internet speed
      </div>

      <div
        class="status"
        [ngClass]="{
          detected: internetStatus === 'Good',
          average: internetStatus === 'Average',
          'not-detected': internetStatus === 'Poor',
        }"
      >
        {{ internetStatus }}

        <span *ngIf="internetSpeed"> ({{ internetSpeed }}) </span>
      </div>
    </div>

    <div>
      <button class="check-btn" (click)="runSystemCheck()">
        Run system check
      </button>
    </div>
  </div>

  <div class="info-box">
    This assessment is AI-evaluated. Results are automatically scored for
    accuracy, time per question, and attempt patterns.
  </div>

  <button class="start-btn" type="button" (click)="openAssessmentLink()">
    Start assessment
  </button>
</div>
